import { LanderV2TrustpilotReview } from "./trustpilotReviews";

type ReviewInitialsAvatarProps = {
  review: LanderV2TrustpilotReview;
};

export function ReviewInitialsAvatar({ review }: ReviewInitialsAvatarProps) {
  return (
    <span
      className="pa-vb-review-avatar"
      style={{
        backgroundColor: review.avatarBackgroundColor,
        color: review.avatarTextColor,
      }}
      aria-hidden="true"
    >
      {review.initials}
    </span>
  );
}
